export default __webpack_public_path__ + "static/media/newslide.31718967.png";